/**
 * Kam sa vrátiť po prihlásení (KOLO 127).
 *
 * Odkaz z programu Tandem Zostavy `/zakazky?koncept=<id>` musí po
 * prihlásení otvoriť ten koncept. Do KOLA 127 sa vracalo len na **cestu**
 * (`from.pathname`), takže `?koncept=…` sa stratilo a user skončil na
 * holom zozname zákaziek.
 *
 * Návrat ide cez `?next=`, nie len cez `state` routera: `state` neprežije
 * úplné načítanie stránky, a presne to robí presmerovanie pri vypršanej
 * session (`api/client.ts` → `window.location.assign`).
 */

/** Adresa prihlásenia, ktorá po úspechu vráti na `ciel`. */
export function loginAdresa(ciel: string): string {
  const bezpecny = bezpecnyNavrat(ciel);
  return bezpecny ? `/login?next=${encodeURIComponent(bezpecny)}` : "/login";
}

/**
 * `ciel`, ak je to adresa **v tejto appke** — inak `null`.
 *
 * Bez kontroly by odkaz `…/login?next=https://cudzia.stranka` po
 * prihlásení poslal usera von z appky (open redirect). Prehliadač
 * `//cudzia.stranka` aj `/\cudzia.stranka` berie ako inú doménu, preto
 * nestačí „začína lomkou". `/login` sa neprijíma, aby sa prihlásenie
 * nevracalo samo na seba.
 */
export function bezpecnyNavrat(ciel: string | null | undefined): string | null {
  if (!ciel) return null;
  if (!ciel.startsWith("/")) return null;
  if (ciel.startsWith("//") || ciel.startsWith("/\\")) return null;
  if (ciel.includes("://")) return null;
  if (ciel === "/login" || ciel.startsWith("/login?") || ciel.startsWith("/login/")) {
    return null;
  }
  return ciel;
}
